import { createContext, useContext } from "react";

import { CountryCode, US_DOMESTIC_COUNTRIES } from "common/constants/address";

type UIContextValue = {
  isPimsUI: boolean;
  isV2UI: boolean;
  isHdEnabled: boolean;
  clinicGroupCountry: CountryCode;
  homeUrl: string;
};

export const UIContext = createContext<UIContextValue>({
  isPimsUI: false,
  isV2UI: false,
  isHdEnabled: true,
  clinicGroupCountry: CountryCode.US,
  homeUrl: "/",
});

export const useUIContext = () => {
  return useContext(UIContext);
};

export const useIsPimsUI = () => {
  const { isPimsUI } = useUIContext();
  return isPimsUI;
};

export const useIsV2UI = () => {
  const { isV2UI } = useUIContext();
  return isV2UI;
};

export const useIsHdEnabled = () => {
  const { isHdEnabled } = useUIContext();
  return isHdEnabled;
};

export const useClinicGroupCountry = () => {
  const { clinicGroupCountry } = useUIContext();
  return clinicGroupCountry;
};

export const useIsUSClinicGroup = () => {
  const { clinicGroupCountry } = useUIContext();
  return clinicGroupCountry in US_DOMESTIC_COUNTRIES;
};
